module.exports = __webpack_public_path__ + "assets/loading.0bfedcce0738d562de473374a286d478.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./img/loading.gif
 ** module id = 283
 ** module chunks = 0
 **/